import { useEffect, useState } from "react";

import { HTTPErrorCallback } from "Helpers/Error";
import moment from "Helpers/MomentCompat";

import UseServices from "Hooks/UseServices";

import * as S from "../Schedule/styles";

// Sessão MATERIAIS APROVADOS (A12 — D24): arquivos de mensagens com status
// "Aprovado" (workflow D23). O backend restringe às conversas em que o
// usuário participa; o link é URL assinada.
const ApprovedMaterials = ({ projectId }) => {
  const { api } = UseServices();

  const [materials, setMaterials] = useState([]);

  useEffect(() => {
    if (!projectId) return;

    api
      .post("/projects/approved-materials", { project_id: projectId })
      .then((response) => setMaterials(response.data?.materials || []))
      .catch((error) => HTTPErrorCallback(error));
    // eslint-disable-next-line
  }, [projectId]);

  return (
    <S.Wrapper>
      <S.Section>
        <span>Materiais Aprovados</span>
        <hr />
      </S.Section>

      {!materials.length ? <span>Nenhum material aprovado.</span> : null}

      {materials.map((material) => (
        <S.Event key={material.id}>
          {/* `title` é o nome que o proponente deu no formulário da sessão
              "Materiais" (19/09/2026). Mensagem comum não tem título e cai no
              nome do arquivo, como antes. */}
          <h2>{material.title || material.file_name || "Arquivo"}</h2>
          <span>
            Enviado por {material.user?.full_name || "—"} em{" "}
            {moment(material.created_at).format("DD/MM/YYYY")}
          </span>
          <a href={material.file_src} target="_blank" rel="noreferrer">
            Abrir arquivo
          </a>
        </S.Event>
      ))}
    </S.Wrapper>
  );
};

export default ApprovedMaterials;
